import { render, staticRenderFns } from "./PlatformAccountModal.vue?vue&type=template&id=14bdb15a&"
import script from "./PlatformAccountModal.vue?vue&type=script&lang=js&"
export * from "./PlatformAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports